import axios from 'axios';

const partnerClient = axios.create({
  baseURL: '/api',
});

export const setPartnerAuthToken = (token) => {
  if (token) {
    partnerClient.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete partnerClient.defaults.headers.common.Authorization;
  }
};

partnerClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      delete partnerClient.defaults.headers.common.Authorization;
    }
    return Promise.reject(error);
  }
);

export default partnerClient;
